import { useApi } from '@backstage/core-plugin-api';
import {
  ReleaseNotesFilters,
  ReleaseNotesList,
} from '@internal/backstage-plugin-release-notes-common';
import { useAsyncRetry } from 'react-use';
import { releaseNotesApiRef } from '../apis';

type UseReleaseNotesPropOptions = {
  dependencies?: any[];
};

export const useReleaseNotes = (
  props: ReleaseNotesFilters,
  options?: UseReleaseNotesPropOptions,
): {
  releaseNotes: ReleaseNotesList;
  loading: boolean;
  error: Error | undefined;
  retry: () => void;
} => {
  const api = useApi(releaseNotesApiRef);

  const {
    value: releaseNotesList,
    loading,
    error,
    retry,
  } = useAsyncRetry(async () => {
    return await api.releaseNotes(props);
  }, [api, ...(options?.dependencies ?? [])]);

  return {
    releaseNotes: releaseNotesList ?? { count: 0, results: [] },
    loading,
    error,
    retry,
  };
};
